module.exports = __webpack_public_path__ + "img/showHow5.5bbc0acf.png";